module.exports = __webpack_public_path__ + "img/title.57f7e718.png";